import { toQuery } from './to-query';

export const getBalanceQuery = () => {
    const params = new URLSearchParams(window.location.search);

    const gameType = params.get('game');
    const userId = params.get('userId');
    const usernum = params.get('sessionId');
    const configId = params.get('configId');

    if (!gameType) {
        throw new Error('No game type');
    }

    if (!userId) {
        throw new Error('No user id');
    }

    if (!usernum) {
        throw new Error('No session id');
    }

    if (!configId) {
        throw new Error('No config id');
    }

    return toQuery({
        gameType,
        userId,
        usernum,
        configId,
    });
};
